
"use strict"


import './polyfills'
import objectFitPolyfill from 'objectFitPolyfill'
import { addHTMLClass } from './utility/browser'
import expand from './modules/expand'
import submenu from './modules/submenu'
import mobileMenu from './modules/mobileMenu'
import type from './modules/type'
import locationMap from './modules/locationMap'
import scrollToTop from './modules/scrollToTop'
import videoLightbox from './modules/videoLightbox'
import tabs from './modules/tabs'
import search from './search'
import videoLines from './modules/videoLines'
import programmesFilter from './modules/programmesFilter'
import programmeFinder from './modules/programmeFinder'
import eventsFilter from './modules/eventsFilter'
import fadeIn from './modules/fadeIn'
import accordion from './modules/accordion'
import calendarButton from './modules/calendarButton'


// init modules

addHTMLClass()
submenu()
scrollToTop()
videoLightbox()
tabs()
videoLines()
locationMap()
search()
programmesFilter()
programmeFinder()
eventsFilter()
fadeIn()
accordion()
calendarButton()


mobileMenu({
	menu: '.site-menu-mobile',
	openClass: 'is-open',
	noScrollClass: 'site-menu-mobile-noscroll',
	overlayClass: 'site-menu-mobile-overlay',
	openSelector: '.js-site-menu-mobile--open',
	closeSelector: '.js-site-menu-mobile--close',
	toggleSelector: '.js-site-menu-mobile--toggle',
})


// initiate basic dom scripts

expand('.button-expand', (open, button, content) => {
	const openClass = 'button-expand--open'
	open ? button.classList.add(openClass) : button.classList.remove(openClass)
})

expand('.menu-expand', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.classList.add(openClass) : button.classList.remove(openClass)
	open ? content.classList.add(openClass) : content.classList.remove(openClass)
})


type('.js-type')